import React from 'react';
import cx from 'classnames';
import T from 'prop-types';
import CheckboxWrapper from '../CheckboxSet/components/CheckboxWrapper';
import CheckboxLabel from '../CheckboxSet/components/CheckboxLabel';
import Checkbox from '../CheckboxSet/components/Checkbox';

const SimpleCheckbox = ({
  id,
  label,
  // states
  checked,
  indeterminate,
  highlighted,
  disabled,
  // appearance
  circle,
  backgroundColor,
  reverse,
  gap,
  withHoverEffect,
  size,
  className,
  wrapperElementType,

  onChange,
}) => (
  <CheckboxWrapper
    gap={gap}
    id={id}
    TypeElement={wrapperElementType}
    disabled={disabled}
    className={cx(className, { 'flex-row-reverse': reverse })}
  >
    <Checkbox
      id={id}
      checked={checked}
      backgroundColor={backgroundColor}
      disabled={disabled}
      withHoverEffect={withHoverEffect}
      size={size}
      indeterminate={indeterminate}
      highlighted={highlighted}
      circle={circle}
      onChange={onChange}
    />
    {label &&
      <CheckboxLabel>
        {label}
      </CheckboxLabel>}
  </CheckboxWrapper>
);

SimpleCheckbox.propTypes = {
  id: T.oneOfType([T.string, T.number]).isRequired,
  label: T.node,
  checked: T.bool.isRequired,
  indeterminate: T.bool,
  highlighted: T.bool,
  disabled: T.bool,
  circle: T.bool,
  backgroundColor: T.string,
  reverse: T.bool,
  gap: T.oneOfType([T.string, T.number]),
  withHoverEffect: T.bool,
  size: T.string,
  className: T.string,
  wrapperElementType: T.string,
  onChange: T.func,
};

export default SimpleCheckbox;
